export default "__VITE_ASSET__B1jSmcv7__"